import {Skeleton} from '@mui/material';

type TagsSelectionType = {
  skeletonChips: number;
};
const TagsSkeleton = ({skeletonChips}: TagsSelectionType) =>
  [...new Array(skeletonChips)].map((_, index) => (
    <Skeleton
      key={`sk_chip_${index}`}
      variant="rounded"
      width={index % 2 ? '15%' : '10%'}
      height={48}
      sx={{
        mt: {xxs: 0, md: 1},
        ml: {xxs: 2, md: 'none'},
        mb: 1,
        borderRadius: 2,
      }}
    />
  ));

export default TagsSkeleton;
